import DailyBoxList from './DailyBoxList'
export {DailyBoxList}
export default DailyBoxList
